import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import MetaDataMap from 'src/features/pv-analysis/components/MetaDataMap';
import Search from 'src/features/pv-analysis/components/Search';
import SelectedBuildingMetadata from 'src/features/pv-analysis/components/SelectedBuildingMetadata';
import { resetImportBuildingFlow, setLocation } from 'src/features/pv-analysis/pv-analysis.slice';
import { useAppDispatch, useAppSelector } from 'src/redux-app-hooks';

type Props = {
    open: boolean;
    onClose: () => void;
    initialCenter: google.maps.LatLngLiteral | null;
    onImported: (location?: google.maps.LatLngLiteral | null) => void;
};

export default function ImportBuildingDialog({ open, onClose, initialCenter, onImported }: Props) {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const dialogLocation = useAppSelector((state) => state.pvAnalysis.location);

    useEffect(() => {
        if (!open) return;
        dispatch(resetImportBuildingFlow());
        if (initialCenter) {
            dispatch(setLocation({ lat: initialCenter.lat, lng: initialCenter.lng, address: '' }));
        }
    }, [open, initialCenter, dispatch]);

    function handleClose() {
        dispatch(resetImportBuildingFlow());
        onClose();
    }

    function handleImportSuccess() {
        onImported(dialogLocation ? { lat: dialogLocation.lat, lng: dialogLocation.lng } : null);
    }

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
            <DialogTitle>{t('Import Building')}</DialogTitle>
            <DialogContent>
                <Grid container spacing={2} sx={{ pt: 1 }}>
                    <Grid size={12}>
                        <Search />
                    </Grid>
                    <Grid size={12} container direction="row" spacing={1} sx={{ height: '32rem' }}>
                        <Grid size={7} sx={{ height: '100%' }}>
                            <MetaDataMap />
                        </Grid>
                        <Grid size={5} sx={{ height: '100%', overflowY: 'auto' }}>
                            <SelectedBuildingMetadata hideReturnButton onImportSuccess={handleImportSuccess} />
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>{t('Cancel')}</Button>
            </DialogActions>
        </Dialog>
    );
}
